// extracted by mini-css-extract-plugin
export default {"products__spinner":"e51a04"};